import axios from "axios";
import { debounce } from "../../lib/utils/debounce.js";
const csrfToken = document.querySelector("meta[name='csrf-token']") ? document.querySelector("meta[name='csrf-token']").content : null;


document.addEventListener('DOMContentLoaded', function () {
  const passwordField = document.querySelector("input.password")
  const form = document.querySelector("#sign_up_form");
  const emailField = document.querySelector("#user_email");
  const submitButton = document.querySelector("input[type='submit']");
  const cguCheckbox = document.querySelector("#user_cgu_accept");

  if (form && emailField && passwordField && submitButton && cguCheckbox) {
    const checkInputs = () => {
      if (emailField.value.trim() !== "" && passwordField.value.trim() !== "" && cguCheckbox.checked) {
        submitButton.disabled = false;
      } else {
        submitButton.disabled = true;
      }
    };

    submitButton.disabled = true; // deactivated by default

    emailField.addEventListener("input", checkInputs);
    passwordField.addEventListener("input", checkInputs);
    cguCheckbox.addEventListener("change", checkInputs);

      // Promo code handling
    const promoButton = document.querySelector(".promo-code-btn");
    const promoField = document.querySelector("#promo-field");
    
    if (promoButton && promoField) {
      const promoInput = promoField.querySelector("input");
      promoButton.addEventListener("click", function () {
        
        if (promoField.classList.contains("d-none")) {
          promoField.classList.remove("d-none");
          promoInput.focus();
          setTimeout(() => promoField.classList.add("show"), 5);
        } else {
          promoField.classList.remove("show");
          setTimeout(() => promoField.classList.add("d-none"), 400);
        }
            

        promoInput.addEventListener("keyup", debounce(() => {
          const sponsorCode = promoInput.value;
          const validationUrl = promoField.dataset.validationUrl;
          const messageWrapper = document.querySelector(".promo-code-message");
          if (sponsorCode.trim() == "") {
            promoInput.classList.remove("is-valid", "is-invalid");
            messageWrapper.classList.add("d-none");
            checkInputs()
            return;
          }
          axios.post(`${validationUrl}/?sponsor_code=${sponsorCode}`, {}, {headers: { "X-CSRF-Token": csrfToken}})
            .then(res => {
              if (res.data.success) { 
                promoInput.classList.add("is-valid");
                promoInput.classList.remove("is-invalid");
                messageWrapper.classList.remove("failure")
                messageWrapper.classList.add("success")
                checkInputs();
              } else {
                promoInput.classList.add("is-invalid");
                messageWrapper.classList.add("failure")
                messageWrapper.classList.remove("success")
                submitButton.disabled = true;
              }
              const message = res.data.message;
              messageWrapper.innerHTML = message;
              messageWrapper.classList.remove("d-none")
            })
            .catch(err => console.log(err))
          }, 700)
        );
      });
    }
  }
})